/**
 * Watchlist state
 */
import { ITicker } from '@kattana-io/common';
import { ACTIVATE, REFRESH, ADD_SUCCESS, REMOVE_SUCCESS } from '../actions/watchlist';

export const LS_WATCHLIST_KEY = 'kattana.watchlist';

export interface IWatchlistState {
  tickers: ITicker[];
}

const defaultState: IWatchlistState = {
  tickers: [],
};

const watchListReducer = (
  state: IWatchlistState = defaultState,
  action: any
) => {
  switch (action.type) {
  case ADD_SUCCESS:
    return {
      tickers: [...state.tickers, action.payload],
    };
  case REMOVE_SUCCESS:
    return {
      tickers: state.tickers.filter((item) => item.id !== action.payload),
    };
  case REFRESH:
    return {
      tickers: action.payload,
    };
  case ACTIVATE:
    return state;
  default:
    return state;
  }
};

export default watchListReducer;
